import CHATBOT_TYPES from './_actionTypes';

export const openChatbot = () => ({ type: CHATBOT_TYPES.CHATBOT_OPEN });
export const closeChatbot = () => ({ type: CHATBOT_TYPES.CHATBOT_CLOSE });
export const toggleChatbot = () => ({ type: CHATBOT_TYPES.CHATBOT_TOGGLE });

export const sendMessageRequest = (message) => ({
  type: CHATBOT_TYPES.SEND_MESSAGE_REQUEST,
  payload: { message },
});

export const appendBotToken = (token) => ({
  type: CHATBOT_TYPES.APPEND_BOT_TOKEN,
  payload: { token },
});

export const clearHistory = () => ({ type: CHATBOT_TYPES.CLEAR_HISTORY });
